import { render } from "./Info.vue?vue&type=template&id=18062722"
const script = {}
script.render = render

export default script